module.exports = __webpack_public_path__ + "media/custom/images/img3-5b827e07385c9266bb6b8f142a02eb6b.svg";